import React, { useEffect } from 'react'
import { background } from 'assets/backgrounds'
import { useArticleTemplate } from 'common/hooks/useArticleTemplate'
import { PostCard } from 'cwp-components/cards/PostCard'

const OurApproach = () => {
  const { results: articles, loadArticles } = useArticleTemplate()
  useEffect(loadArticles, [loadArticles])
  const lastArticle = articles?.length ? articles[articles.length - 1] : null
  return (
    <div className='relative w-full mb-36'>
      <img
        src={background.discoverLawTemplate._02}
        alt='Background'
        className='absolute top-5 left-0 w-full max-w-[1200px] h-[400px] -z-10'
      />
      <div className='relative px-2.5 sm:px-4 md:p-6 lg:px-10 xl:px-16 2xl:px-20 box-border'>
        <h3 className='text-2xl sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl 2xl:text-[40px] font-bold text-[#101828] leading-none tracking-wide mt-2'>
          Our approach is your solution
        </h3>

        <h6 className='text-[#25395C] leading-6 text-sm md:text-base lg:text-lg tracking-wide font-medium md:font-bold my-1'>
          Preview the content directly — just click on an article or blog to get
          a glimpse before diving in!
        </h6>

        <div className='mx-auto w-full max-w-[1440px]'>
          <div className='flex md:flex-row flex-wrap gap-[15px] lg:gap-[24px]'>
            {articles?.slice(4, 8).map((blog, idx) => (
              <PostCard
                className='min-h-[371px] h-full w-[330px] mx-auto'
                data={blog}
                count={idx}
                key={`${blog.title}-${blog.id}`}
              />
            ))}
          </div>

          <div className='mt-5 w-full'>
            {lastArticle && (
              <div className='mt-4 w-full'>
                <PostCard
                  className='h-full w-full mx-auto'
                  data={lastArticle}
                  isActive={true}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
export default OurApproach
